export default "__VITE_ASSET__BXWjfKy2__"